import { render, staticRenderFns } from "./generateSnapshot.vue?vue&type=template&id=2b2b3ba0&scoped=true"
import script from "./generateSnapshot.vue?vue&type=script&lang=js"
export * from "./generateSnapshot.vue?vue&type=script&lang=js"
import style0 from "./generateSnapshot.vue?vue&type=style&index=0&id=2b2b3ba0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2b3ba0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b2b3ba0')) {
      api.createRecord('2b2b3ba0', component.options)
    } else {
      api.reload('2b2b3ba0', component.options)
    }
    module.hot.accept("./generateSnapshot.vue?vue&type=template&id=2b2b3ba0&scoped=true", function () {
      api.rerender('2b2b3ba0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dollars/components/generateSnapshot.vue"
export default component.exports